import { FormGroup, Switch } from "@blueprintjs/core";
import { FieldLabeledProps, SwitchProps } from "../../types/fieldTypes";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { useSwitchField } from "./useSwitchField";

/** Base SwitchField Props*/
export interface SwitchFieldProps extends SwitchProps {
  labelOnTop?: boolean;
  labelProps?: FieldLabeledProps;
  handleClick?: () => void;
}

const SwitchField: React.FC<SwitchFieldProps> = (props) => {
  const { localValue, setLocalValue } = useSwitchField(props);

  return (
    <div className="ucl-base-input-switch-field-container">
      <FormGroup
        className={`${
          props.isRequired && !localValue
            ? "has-required-background"
            : "base-field"
        }`}
      >
        {props.labelOnTop && props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValue }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        <Switch
          label={props.labelOnTop ? undefined : (props.label as string)}
          disabled={props.disabled}
          checked={localValue ?? false}
          onChange={() => {
            setLocalValue(!(localValue ?? false));
          }}
          onClick={props.handleClick}
          large={props.large}
        />
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default SwitchField;
